import { render, staticRenderFns } from "./Author.vue?vue&type=template&id=6ae917fe&scoped=true&"
import script from "./Author.vue?vue&type=script&lang=js&"
export * from "./Author.vue?vue&type=script&lang=js&"
import style0 from "./Author.vue?vue&type=style&index=0&id=6ae917fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../rebuild/yeh/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae917fe",
  null
  
)

export default component.exports